import Model, { attr } from '@ember-data/model';

export default class LocaleModel extends Model {
  @attr
  declare name: string;

  @attr
  declare key: string;

  @attr
  declare direction: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    locale: LocaleModel;
  }
}
